import { useCallback, useState } from "react";

/** Counts the things mounted under a provider, such as a page's crumb bars; `register` is stable, as mounts register in an effect. */
export const useMountCount = () => {
  const [count, setCount] = useState(0);
  const register = useCallback(() => {
    setCount((previous) => previous + 1);
    return () => setCount((previous) => previous - 1);
  }, []);
  return { count, register };
};
